var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCargasEdicion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.26 102.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "message",
    className: "cls-1",
    d: "M18.91,90.66c-7.53,0-13.64-6.1-13.64-13.63h0v-22.74c0-.69.16-1.37.46-1.99l15.71-35.34c2.18-4.93,7.07-8.12,12.47-8.11h42.73c5.4,0,10.29,3.17,12.48,8.11l15.77,35.49c.26.58.39,1.21.39,1.84v22.73c0,7.53-6.1,13.63-13.63,13.64H18.91ZM14.36,77.02c0,2.51,2.03,4.54,4.54,4.55h72.73c2.51,0,4.55-2.04,4.55-4.55v-18.17h-20.29l-7.74,11.61c-.84,1.27-2.26,2.03-3.78,2.02h-18.18c-1.52,0-2.94-.75-3.78-2.02l-7.74-11.61H14.36v18.17ZM37.09,49.75c1.52,0,2.94.76,3.78,2.02l7.74,11.61h13.32l7.74-11.61c.84-1.26,2.26-2.02,3.78-2.02h20.28l-12.93-29.11c-.73-1.64-2.36-2.7-4.16-2.7h-42.73c-1.8,0-3.43,1.06-4.16,2.7l-12.93,29.11h20.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCargasEdicion);
export default __webpack_public_path__ + "static/media/logo_cargas_edicion.fe07cb4d3b99b514bf82031161939365.svg";
export { ForwardRef as ReactComponent };